import { Button, TextField } from '@mui/material';
import React from 'react';
import Loading from '../../components/Loading';
import { Stack } from '@mui/system';
import { useCreateContractMutation, useDeleteContractMutation, useUpdateContractMutation } from '../../features/model/contractSlice';
import { DatePicker, DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const AddContractCard = ({salesrep}) => {
    const [addObject, {isLoadingUpdate: isUpdating}] = useCreateContractMutation();

    if (isUpdating) {
        return <Loading />
    }

    function onAddNew(commission) {
        addObject({salesrep: salesrep.id, commission: parseFloat(commission)})
    }

    return <Stack sx={{margin: 2}} spacing={2}>
        <TextField
              sx={{marginTop: 2}}
              placeholder='Type commission % and press enter...'
              onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    onAddNew(e.target.value);
                    e.target.value = "";
                  }
              }}
          />
    </Stack>;

}

const ContractCard = ({object}) => {
    const [updateObject, {isLoadingUpdate: isUpdating }] = useUpdateContractMutation();
    const [deleteObject] = useDeleteContractMutation();

    if ( isUpdating) {
      return <Loading />;
    }

    return <Stack sx={{margin: 2}} spacing={2} direction={"row"}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker label="Start date" defaultValue={dayjs.utc(object.startdate).local()} onChange={(newValue) => {
                    updateObject({contract_id: object.id, data: {startdate: dayjs(newValue).utc()}});
                }} />
                <DatePicker label="End date" defaultValue={dayjs.utc(object.enddate).local()} onChange={(newValue) => {
                    updateObject({contract_id: object.id, data: {enddate: dayjs(newValue).utc()}});
                }} />
            </LocalizationProvider>
            <TextField value={`${object.commission}`} onChange={(event) => {
                let newValue = parseFloat(event.target.value);
                updateObject({contract_id: object.id, data: {commission: newValue}});
            }} />
            <Button variant={"outlined"} onClick={() => {
                    deleteObject(object.id)
                }
            }>Delete</Button>
        </Stack>;
}

export { ContractCard, AddContractCard };
